import React from 'react'
import { Link, withRouter } from 'react-router-dom'

import { Svg, Icon, ContactBubbles, Breadcrumbs } from '@components/shared/elements'

import Newsletter from '@components/children/Newsletter'

import './PageFooter.scss'
import ModalWhatsapp from '@components/children/contactForm/ModalWhatsapp'
import ModalChat from '@components/children/contactForm/ModalChat'
import ModalEmail from '@components/children/contactForm/ModalEmail'
import ModalCall from '@components/children/contactForm/ModalCall'
import ModalObra from '@components/children/contactForm/ModalObra'
import ModalWelcome from '@components/children/contactForm/ModalWelcome'

import $ from 'jquery'
import slugify from 'slugify'
import { isEmpty } from 'lodash'

import { HashLink } from 'react-router-hash-link'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as SHARED_ACTION from '@store/shared/actions'

import TOOLS from '@helpers/tools'

class PageFooter extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      modalWhats: undefined,
      modalChat: undefined,
      modalEmail: undefined,
      modalCall: undefined,
      modalObra: undefined,
      modalWelcome: undefined,
      queries : {
        p: false,
      },
      showModal: true,
    }
    this.el = React.createRef()
  }

  _checkUrl() {
    const currentPath = window.location.pathname
    let pdp = ''
  
    if (currentPath.includes('/apartamento')) {
      pdp = true
    } else {
      pdp = false
    }
    return pdp
  }

  _createWhatsappUrl(event, phone, typeIntegrationLead, idImovel) {
    const { imovel, region } = this.props
    const gaWhatsAppFunction = this._gaWhatsapp
    let pdp = this._checkUrl()
    TOOLS.createWhatsappUrl({
      event,
      imovel,
      region,
      gaWhatsAppFunction,
      phone,
      typeIntegrationLead,
      pdp,
      idImovel,
    })
  }

  componentDidMount() {
    $(this.el.current).foundation()
    const queries = this._catchURLParams()
    if (queries) {
      this.setState(state => {
        return { ...state, queries }
      })
    }
  }

  _openModalHandler(modalName) {
    this._openModal(modalName)
  }

  _openModal(modal, goback = false) {
    this.props.actions.setContactModalsState(this.props.contactModals, modal, true)
    this.props.actions.optionsModals(goback)
  }

  _catchURLParams () {
    if (this.props.location.search) {
      let values = this.props.location.search
      if (values) {
        values = values.split('?')[1]
        if (values) {
          values = values.split('&')
          const queries = values.reduce((acc, v) => {
            const obj = v.split('=')
            acc[obj[0]] = obj[1] === 'true'
            return acc
          }, {})
          return queries
        }
      }
    }
  }

  _gaWhatsapp = (element) => {
    const REGION_RJ_ID = 22
    const { region, phone } = this.props
    if (
      (isEmpty(phone) || phone.TelefoneVendaContatoWhatsApp === null) &&
      region === REGION_RJ_ID
    ) {
      element.preventDefault()
      element.stopPropagation()
      this._openModal('modalWhats')
    }
    const elementText = element._targetInst !== null ? slugify(element.target.innerText, { lower: true }) : 'whatsapp'
    const timeStamp = Date.now()
    let dataLayer = window['dataLayer']
    let page = window.location.pathname.split('/')[1]

    if (isEmpty(page)) {
      page = 'home'
    }

    if (dataLayer) {
      let ecommerce = {}
      if (window.location.href.indexOf('apartamento/') > 0) {
        const product = this.props.product.imovel
        let nome = slugify(product.Nome, { lower: true }),
            estado = slugify(product.Localizacao.Estado, { lower: true }),
            cidade = slugify(product.Localizacao.Cidade, { lower: true }),
            bairro = slugify(product.Localizacao.Bairro, { lower: true }),
            marca = 'vivaz',
            preco = new Intl.NumberFormat('pt-BR').format(product.PrecoMinimo)
        ecommerce = {
          purchase:{
            actionField:{
              id: `${timeStamp}`,
            },
            products: {
              id: `${product.imovelId}`,
              name: `${nome}`,
              brand: `${marca}`,
              category: `${estado}/${cidade}`,
              variant: `${bairro}/${product.Quartos}/${product.AreaPrivativaM2}`,
              price: `${preco}`,
            },
          },
        }
      } else {
        ecommerce = {
          purchase:{
            actionField:{
              id: `${timeStamp}`,
            },
            products: {
              id: 'na',
              name: 'na',
              brand: 'vivaz',
              category: 'na',
              variant: 'na',
              price: 1,
            },
          },
        }
      }
      dataLayer.push({
        'event': 'purchase',
        'eventCategory': `${page}`,
        'eventAction': `${elementText}:click`,
        'eventLabel': `${elementText}:${timeStamp}`,
        ecommerce,
      })
    }
  }

  _handlePushDataLayer(event, key) {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'clickEvent',
        'eventCategory': key,
        'eventAction': event.type || 'click',
        'eventLabel': 'instituto-cyrela-footer:instituto-cyrela',
        'eventNonInteraction': '0',
      })
    }
  }

  _handleConsentCookiesBanner(event) {
    event.preventDefault()
    if (window) {
      window.cookieconsent.privacyToolsShowCookieNotice()
    }
  }

  render() {
    if (this.state.queries.p && !this.props.contactModals.modalWelcome) {
      this.setState({ queries:{ p: false } })
      this._openModal('modalWelcome')
    }
    let { phone } = this.props
    if (!isEmpty(phone)) {
      if (phone.TelefoneVendaContatoMobile) {
        phone.TelefoneVendaContatoMobileH = phone.TelefoneVendaContatoMobile.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
      }
      if (phone.TelefoneVendaContatoWhatsApp) {
        phone.TelefoneVendaContatoWhatsAppH = phone.TelefoneVendaContatoWhatsApp.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
      }
      if (phone.TelefoneRelacionamento) {
        phone.TelefoneRelacionamentoH = phone.TelefoneRelacionamento.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
      }
    }

    let idImovel = 0

    if (this.props.product.imovel != null) {
      idImovel = this.props.product.imovel.imovelId
    }

    const REGION_SP_ID = 1
    // const REGION_RJ_ID = 22
    const REGION_RS_ID = 24

    const currentPage = window.location.pathname.split('/')[1]
    const isRealtorPage = currentPage === 'vendedor'
    const isContactPage = currentPage === 'contato'
    const isCyrelaInstitutePage = currentPage === 'instituto-cyrela'
    // const productHasContactSplitting = !isEmpty(this.props.imovel) ? this.props.imovel.IntegraSomenteMobi : false
    let contactLink = '/contato'

    let prime = false
    let simulatorLink = '/simulador'
    let hideContacts = false
    let hideSimulator = false
    if (currentPage === 'apartamento' && !!this.props.imovel && !isEmpty(this.props.imovel)) {
      hideContacts = this.props.imovel.RemoverLinkWhatsapp
      hideSimulator = this.props.imovel.RemoverLinkSimulador
      const imovelCode = !!this.props.imovel && !!this.props.imovel.imovelId ?
        this.props.imovel.imovelId : '0'
      const imovelFacilita = !!this.props.imovel && !!this.props.imovel.IdFacilita ?
        this.props.imovel.IdFacilita : '0'
      contactLink += `?idimovel=${imovelCode}`
      simulatorLink = `/simulador/?idimovel=${imovelCode}`
      if (imovelFacilita) {
        simulatorLink += `&idFacilita=${imovelFacilita}`
      }
      prime = this.props.imovel.ProdutoPrime
    }



    return (
      <footer className={`page-footer ${prime ? 'prime-footer' : ''}${isCyrelaInstitutePage ? ' institute-footer' : ''}`} ref={this.el} data-ga-name='footer:'>
        {this.props.showNewsletter && <Newsletter location={this.props.location} prime={prime}/> }
        <div data-module='rodape' className={currentPage === 'casavivaz' ? 'bg-grey' : ''}>
          {currentPage === 'casavivaz' && (
            <div className='grid-container'>
              <div className='casa-vivaz'>
                <ul className='menu social'>
                  <li><a href='https://www.instagram.com/vivazresidencial/' title='Instagram' target='_blank' rel='noopener noreferrer'>
                    <Svg src='/Files/vivaz.com.br/content/img/icons/instagram.svg' />
                  </a></li>
                  <li><a href={`https://www.facebook.com/vivazresidencial${this.props.region === REGION_RS_ID ? 'rs' : ''}`} title='Facebook' target='_blank' rel='noopener noreferrer'>
                    <Svg src='/Files/vivaz.com.br/content/img/icons/facebook.svg' />
                  </a></li>
                  <li><a href='https://www.youtube.com/channel/UCILQRg7uTli8psTylY2MZ-w' title='Youtube' target='_blank' rel='noopener noreferrer'>
                    <Svg src='/Files/vivaz.com.br/content/img/icons/youtube.svg' />
                  </a></li>
                  <li className='hide'><a href='https://twitter.com/' title='Twitter' target='_blank' rel='noopener noreferrer'>
                    <Svg src='/Files/vivaz.com.br/content/img/icons/twitter.svg' />
                  </a></li>
                </ul>
                <p>Nos acompanhe também nas redes sociais</p>
              </div>
            </div>
          )}
          {!isRealtorPage && <Breadcrumbs />}
          <section id='rodape' className='site-infos'>
            <div className='clearfix'>
              <div className='grid-container mt8 mb8'>
                {!isRealtorPage &&
                  <div className='grid-x grid-margin-y'>
                    <div className='cell auto '>
                      <div className='site-infos__extra '>
                        <div className='grid-x mb3'>
                          <div className='cell medium-6 large-3 site-infos__extra__contact'>
                            {!hideContacts && !isEmpty(phone) && phone.TelefoneVendaRodapeVivaz != null &&
                              <div className='mb2'>
                                <h6 className='text-medium mb0'>Vendas por telefone</h6>
                                <h5 className='text-xx-large mb0'><strong>{phone.TelefoneVendaRodapeVivaz}</strong></h5>
                              </div>
                            }
                            <ul data-ga-name='modal-contato'>
                              {
                                +this.props.region !== REGION_SP_ID && (
                                  <li>
                                    <button
                                      onClick={() => this._openModal('modalChat')}
                                      data-ga-action
                                    >
                                      <Svg src='/Files/vivaz.com.br/content/img/icons/ico-chat_bubbles.svg' /> Chat Online</button>
                                  </li>
                                )
                              }
                              {!hideContacts &&
                                <li>
                                  {!isEmpty(phone) && phone.TelefoneVendaContatoWhatsAppH &&
                                    <button
                                      onClick={event => this._createWhatsappUrl(
                                        event,
                                        phone.TelefoneVendaContatoWhatsAppH,
                                        phone.TipoGuidIntegracao,
                                        idImovel
                                      )}
                                      data-ga-action>
                                        <Svg src='/Files/vivaz.com.br/content/img/icons/ico-whatsapp.svg' />
                                        Whatsapp
                                    </button>
                                  }
                                  {!isEmpty(phone) && !phone.TelefoneVendaContatoWhatsAppH &&
                                    <button
                                      onClick={() => this._openModal('modalWhats')}
                                      data-ga-action>
                                      <Svg src='/Files/vivaz.com.br/content/img/icons/ico-whatsapp.svg' /> Whatsapp
                                    </button>
                                  }
                                </li>
                              }

                              {+this.props.region !== REGION_SP_ID && (
                                <React.Fragment>
                                  <li>
                                    <button
                                      onClick={() => this._openModal('modalEmail')}
                                      data-ga-action
                                    >
                                      <Svg src='/Files/vivaz.com.br/content/img/icons/ico-e-mail.svg' /> E-mail
                                    </button>
                                  </li>
                                  {!isEmpty(phone) && phone.TelefoneVendaContatoMobileH != null ? (
                                    <li className='show-for-small-only'>
                                      <a href={`tel:+55${phone.TelefoneVendaContatoMobileH}`} data-ga-action>
                                        <Svg src='/Files/vivaz.com.br/content/img/icons/receive-call.svg' /> Ligamos para você
                                      </a>
                                    </li>
                                  ) : (
                                    <li>
                                      <button
                                        onClick={() => this._openModal('modalCall')}
                                        data-ga-action
                                      >
                                        <Svg src='/Files/vivaz.com.br/content/img/icons/receive-call.svg' /> Ligamos para você
                                      </button>
                                    </li>
                                  )}
                                </React.Fragment>
                              )}

                              {!isRealtorPage && !isContactPage && +this.props.region === REGION_SP_ID && (
                                <li>
                                  <button
                                    onClick={() => this._openModal('modalEmail')}
                                    data-ga-action
                                  >
                                    <Svg src='/Files/vivaz.com.br/content/img/icons/ico-mail.svg' /> Contato
                                  </button>
                                </li>
                              )}

                              {!isRealtorPage && !isContactPage && +this.props.region !== REGION_SP_ID && (
                                <li>
                                  <Link to={contactLink}>
                                  <Svg src='/Files/vivaz.com.br/content/img/icons/ico-mail.svg' /> Contato
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </div>
                          <div className='cell medium-6 large-4'>
                            {!hideSimulator && !this.props.location.pathname.includes('simulador-cva-mcmv') &&
                              <Link to={simulatorLink} className='simulate-button button expanded mb2' data-ga-action='cta-simular-financiamento:'>Simular financiamento</Link>
                            }

                            <ul className='site-map menu vertical menu-middle'>
                              <li className='main-title mb2'>
                                <h6 className='text-xx-large'><strong>Sobre a Vivaz</strong></h6>
                              </li>
                              <li className='noPadding'>
                                <ul className='accordion dark mb0' data-accordion data-allow-all-closed='true'>
                                  <li className='accordion-item pt0' data-accordion-item>
                                    <a className='accordion-title text-large'>Grupo Cyrela</a>
                                    <div className='accordion-content text' data-tab-content>
                                      <ul className='menu vertical mb0'>
                                        <li className='noPadding'>
                                          <a href='https://www.cyrela.com.br' target='_blank' data-ga-action='link-grupo-cyrela' rel='noopener noreferrer'>Cyrela</a>
                                        </li>
                                        <li className='noPadding'>
                                          <a href='https://www.meuliving.com.br' target='_blank' data-ga-action='link-grupo-living' rel='noopener noreferrer'>
                                            Living
                                          </a>
                                        </li>
                                        <li className='noPadding'>
                                          <a href='https://www.cashme.com.br/?utm_group=organic&utm_source=linkbuilding&utm_medium=LinkFooter&utm_campaign=Vivaz' target='_blank' data-ga-action='link-cashMe' rel='noopener noreferrer'>
                                            CashMe
                                          </a>
                                        </li>
                                        <li className='pb2'>
                                          <a href='http://integridade.cyrela.com.br/' target='_blank' data-ga-action='link-integridade-cyrela' rel='noopener noreferrer'>
                                              Integridade Cyrela
                                          </a>
                                        </li>
                                        <li className='pb2'>
                                          <a href='http://integridade.cyrela.com.br/privacidade/' target='_blank' data-ga-action='link-portal-da-privacidade' rel='noopener noreferrer'>
                                              Portal da Privacidade
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li className='bb1'>
                                <button className='text-large' onClick={() => this._openModal('modalObra')} data-ga-action>Sou vizinho de uma obra</button>
                              </li>
                              <li className='menu-vivico'>
                                <HashLink to='/sobre-nos#vivico'>Conheça o Vivico</HashLink>
                              </li>
                              <li>
                                <Link to='/casavivaz'>Casa Vivaz</Link>
                              </li>
                              <li>
                                <Link to='/instituto-cyrela' onClick={(event) => this._handlePushDataLayer(event, 'instituto-cyrela')}>Instituto Cyrela</Link>
                              </li>
                              {
                                (+this.props.region === REGION_SP_ID && currentPage !== 'mapa-de-lojas') && (
                                  <li>
                                    <Link to='/mapa-de-lojas'>Mapa de Lojas</Link>
                                  </li>
                                )
                              }
                              <li>
                                <Link to='/sala-de-imprensa'>Sala de Imprensa</Link>
                              </li>
                              <li>
                                <a href='https://lp.cyrela.com.br/sustentabilidade' target='_blank' rel='noopener noreferrer'>
                                  Sustentabilidade
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div className='cell auto cliente-footer'>
                            <ul>
                              <li>
                                <h6 className='text-xx-large mb0'><strong>Já sou cliente</strong></h6>
                              </li>
                              <li>
                                <a href='https://relacionamentovivaz.com.br' className='underline' data-ga-action='link-portal-do-cliente' target='_blank' rel='noopener noreferrer'>Clique aqui e acesse o portal do cliente</a>
                              </li>
                              <li>
                                <h6 className='text-medium'>Central de relacionamento</h6>
                                <h6 className='text-medium'>11 4000 1280</h6>
                                <h6 className='text-medium'>Seg a Qui das 09h00 às 17h00</h6>
                                <h6 className='text-medium'>Sex 09h00 às 16h00</h6>
                                <h6 className='text-medium'>*Custo de ligação local</h6>
                              </li>
                              </ul>
                            <ul className='menu social'>
                              <li><a href='https://www.instagram.com/vivazresidencial/' title='Instagram' target='_blank' rel='noopener noreferrer'>
                                <Svg src='/Files/vivaz.com.br/content/img/icons/instagram.svg' />
                              </a></li>
                              <li><a href={`https://www.facebook.com/vivazresidencial${this.props.region === REGION_RS_ID ? 'rs' : ''}`} title='Facebook' target='_blank' rel='noopener noreferrer'>
                                <Svg src='/Files/vivaz.com.br/content/img/icons/facebook.svg' />
                              </a></li>
                              <li><a href='https://www.youtube.com/channel/UCILQRg7uTli8psTylY2MZ-w' title='Youtube' target='_blank' rel='noopener noreferrer'>
                                <Svg src='/Files/vivaz.com.br/content/img/icons/youtube.svg' />
                              </a></li>
                              <li className='hide'><a href='https://twitter.com/' title='Twitter' target='_blank' rel='noopener noreferrer'>
                                <Svg src='/Files/vivaz.com.br/content/img/icons/twitter.svg' />
                              </a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='cell shrink'>
                      <a href='#header' data-smooth-scroll className='button button-back-top mb0'>
                        <Icon icon='chevron-up' />
                      </a>
                    </div>
                  </div>
                }
              </div>
            </div>
        </section>
      </div>


        <div className='site-copy text-small clearfix'>
          <div className='grid-container mt2 mb2'>
            <div className='grid-x grid-margin-x align-justify'>
              <div className='cell medium-shrink'>
                <p className='mb0'>® Vivaz Residencial Ltda. CRECI-SP J-17.592 Empresa do grupo Cyrela.</p>
              </div>
              <div className='cell medium-shrink'>
                <Link to='/termos-privacidade'>Termos e Privacidade</Link>
              </div>
              <div className='cell medium-shrink'>
                <a href='/' onClick={this._handleConsentCookiesBanner} className='optanon-show-settings optanon-toggle-display'> Preferências de Cookies </a>
              </div>
            </div>
          </div>
        </div>
        {!isRealtorPage && !isContactPage &&
          <ContactBubbles />
        }
        <ModalWhatsapp
          show={this.props.contactModals.modalWhats}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalWhats', false)
            this.props.actions.highlightModal('', '')
          }}
          goback={this.props.optionsModals}
        ></ModalWhatsapp>
        <ModalChat
          show={this.props.contactModals.modalChat}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalChat', false)
            this.props.actions.highlightModal('', '')
          }}
          goback={this.props.optionsModals}
        ></ModalChat>
        <ModalEmail
          show={this.props.contactModals.modalEmail}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalEmail', false)
            this.props.actions.highlightModal('', '')
          }}
          goback={this.props.optionsModals}
        ></ModalEmail>
        <ModalCall
          show={this.props.contactModals.modalCall}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalCall', false)
            this.props.actions.highlightModal('', '')
          }}
          goback={this.props.optionsModals}
        ></ModalCall>
        <ModalObra
          show={this.props.contactModals.modalObra}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalObra', false)
          }}
          goback={this.props.optionsModals}
        ></ModalObra>
        <ModalWelcome
          show={this.props.contactModals.modalWelcome}
          close={() => {
            this.props.actions.setContactModalsState(this.props.contactModals, 'modalWelcome', false)
          }}
          goback={this.props.optionsModals}
        ></ModalWelcome>

      </footer>
    )
  }
}

const mapStateToProps = state => {

  return {
    contactModals: state.shared.contactModals,
    product: state.products.product,
    phone: state.shared.phone,
    region: state.shared.region,
    showNewsletter: state.shared.showNewsletter,
    imovel: state.products.product.imovel,
    highlightModal: state.shared.highlightModal,
    shBranchId: state.shared.shBranchId,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageFooter))



// WEBPACK FOOTER //
// ./src/components/shared/PageFooter/PageFooter.js